export default __webpack_public_path__ + "static/media/lhd.a1982040.png";